import Requester from '../../helpers/requester';
import { API_PATHS } from '../../helpers/endpoints';
import { HTTP_METHODS } from '../../helpers/constants';

export default {
  collectionAndDeliveryDelay: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.REPORTS}/order/collection-and-delivery-delay/count`,
        data
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getCollectionAndDeliveryDelayByReportType: async (config) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.REPORTS}/order/collection-and-delivery-delay${config.queryString}`,
        data: config.body,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  reportsGenerate: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.REPORTS}/generate`,
        data
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  metricDefinitions: async (data,type) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.GET,
        url: `${API_PATHS.METRIC_DEFINITIONS}?target=${type}`,
        data: data ?? {},
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getKpiReports: async (data, path, selectedDate) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.REPORTS}${path}/${selectedDate}`,
        data
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getReports: async (payload, selectedDate) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.REPORTS}/complaint-rate/${selectedDate}`,
        data: payload
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};
